import { Icons } from "@caspeco/casper-ui-library";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { useTranslation } from "react-i18next";
import ErrorTemplate from "./error-template";

export default function ExpiredLink() {
    const { t } = useTranslation();

    usePageTracking({
        pageName: "ExpiredLinkError",
        pageType: PageType.Page,
    });

    return (
        <ErrorTemplate
            icon={Icons.LinkBroken}
            title={t("errorInformation.expiredLink")}
            message={t("errorInformation.expiredLinkText")}
        />
    );
}
